import React from 'react';
import EditPaymentSettingComponent from '../../../Components/PaymentSetting/EditPaymentSetting';

export default function EditPaymentSetting() {
    return (
        <div className='page-body'>
            <EditPaymentSettingComponent />
        </div>
    );
}